module.exports = __webpack_public_path__ + "img/MoMobil3.52b9a490.png";